export const apiPrefix = '/api'

const endpointConfig = {
    signIn: '/app/user/login',
    signOut: '/app/user/logout',
    signUp: '/app/user/register',
    forgotPassword: '/app/user/forgot-password',
    resetPassword: '/app/user/reset-password',
}

export default endpointConfig
